
export default function Hero() {
  return (
    <section className="relative w-full h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="/assets/img/decor-15.webp"
        alt="Bespoke Decor"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/45 to-black/60"></div>
      <div className="relative z-10 text-center w-full px-4">
        <h1 className="text-6xl md:text-7xl font-extrabold text-white mb-5 tracking-tight leading-tight">
          Bespoke Decor
        </h1>
        <p className="text-xl md:text-2xl text-white/85 mb-10 font-light max-w-2xl mx-auto">
          We don&apos;t just set up tents - we create immersive experiences
        </p>
      </div>
    </section>
  );
}
